// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "mp-report-message-banner{display:block}:host{display:block}.mp-message-banner-container{display:none}.mp-message-banner-container.mp-message-banner-visible{display:block}.mp-message-banner-container mp-banner{margin:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
